import { FC } from 'react';
import { useHasPermission } from '@/entities/profile';
import { useReportRule } from '../model';
import { ReportReferenceDialog } from './ReportReferenceDialog';

type Props = {
  ruleId?: number;
  expertReportId: number;
  blockId: number;
  onClose: () => void;
};

export const RuleDetailDialog: FC<Props> = ({ ruleId, expertReportId, blockId, onClose }) => {
  const { title, name, text, isLoading, path } = useReportRule({ ruleId, expertReportId, blockId });
  const canViewExpertReport = useHasPermission('VIEW_EXPERT_REPORT');
  return (
    <ReportReferenceDialog
      isOpen={!!ruleId}
      title={`${title}: ${name}`}
      text={text}
      isLoading={isLoading}
      // Переход ведёт туда, где открытое живёт в устройстве своего заключения
      linkPath={canViewExpertReport ? path : undefined}
      onClose={onClose}
    />
  );
};
